import React, { useEffect, useRef, useState } from "react";
import { useGetClientsQuery } from "../../../app/features/apiSlice";
import Loader from "../../../components/Loader";
import Error from "../../../components/Error";
import { Badge, ButtonGroup, Card } from "react-bootstrap";
import { Column } from "primereact/column";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../../helpers";
import SetPageTitle from "../../../components/SetPageTitle";
import { apiSlice } from "../../../app/features/apiSlice";
import ExportCSVButton from "../../../components/exportcsv/ExportCsvButton";
import moment from "moment";
import SearchBox from "../../../components/SearchBox";
import ReusableDataTable from "../../../components/ReusableDataTable";

const initialSorting = {
  sortBy: "name",
  sortOrder: 1,
};

const ListClient = () => {
  const sessionId = useRef(Date.now()).current;
  const { t } = useTranslation();
  const { lang } = useParams();
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [sorting, setSorting] = useState(initialSorting);
  const { data, isLoading, isSuccess, isError, error, isFetching } =
    useGetClientsQuery({
      ...sorting,
      sessionId,
      searchQuery: searchQuery,
      page: currentPage,
      limit: 10,
    });

  const processItemForExport = (item) => {
    return {
      [t("name")]: `${item.customer.first_name} ${item.customer.last_name} `,
      [t("email")]: item.customer.email,
      [t("mobilePhone")]: item.customer.phone,
      [t("status")]: item.customer.status ? "Active" : "Inactive",
      [t("kycStatus")]: item.customer.kyc_status || "N/A",
    };
  };

  useEffect(() => {
    if (isSuccess) {
      const items = data?.data;
      const tableItem = [];
      if (items.length > 0) {
        items.forEach((item) => {
          tableItem.push({
            name:
              item?.customer?.organizationUser?.type === "COMPANY"
                ? item?.customer?.organizationUser?.company_name
                : `${capitalizeFirstLetter(
                    item?.customer?.first_name,
                  )} ${capitalizeFirstLetter(
                    item?.customer?.last_name,
                  )}`.trim(),
            email: item?.customer?.email,
            phone: item?.customer?.phone,
            id: item?.customer?.id,
            status: item?.customer?.organizationUser?.status,
            kyc_status: item?.customer?.kyc_status,
            createdAt: moment(item?.customer?._date_register).format(
              "DD-MM-YYYY",
            ),
          });
        });
      }
      // const sortedItems = [...tableItem].sort((a, b) =>
      //   a.name?.localeCompare(b.name)
      // );
      // setTableData(sortedItems);
      setTableData(tableItem);
    }
  }, [isSuccess, data]);

  const totalRecords = data?.pagination?.total || 0;

  if (isLoading) return <Loader />;
  if (isError) return <Error error={error} />;
  return (
    <Card bg="dark1 text-light">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <SetPageTitle title="sidebar.clients" />
        <div className="d-flex justify-content-between align-items-center">
          <ExportCSVButton
            apiFn={apiSlice.endpoints.getClients.initiate}
            processItem={processItemForExport}
            filenamePrefix="export_client_list"
            queryParams={{
              sessionId,
              searchQuery,
              ...sorting,
            }}
          />
          <SearchBox
            setCurrentPage={setCurrentPage}
            setSearchQuery={setSearchQuery}
          />
        </div>
      </Card.Header>
      <Card.Body>
        <ReusableDataTable
          tableData={tableData}
          currentPage={currentPage}
          totalRecords={totalRecords}
          isLoading={isLoading}
          isFetching={isFetching}
          sorting={sorting}
          searchQuery={searchQuery}
          setSorting={setSorting}
          setCurrentPage={setCurrentPage}
          initialSorting={initialSorting}
        >
          <Column sortable field="name" header={t("client")}></Column>
          <Column sortable field="email" header={t("form.email")}></Column>
          <Column
            sortable
            field="phone"
            header={t("form.mobileNumber")}
          ></Column>
          <Column
            sortable
            field="status"
            header={t("status")}
            body={(rowData) => (
              <Badge
                bg={`${rowData.status === "Active" ? "success" : "secondary"}`}
              >
                {rowData.status === "Active" ? t("active") : t("inactive")}
              </Badge>
            )}
          ></Column>
          <Column
            sortable
            field="kyc_status"
            header={t("kycStatus")}
            body={(rowData) =>
              rowData.kyc_status !== null ? t(`${rowData.kyc_status}`) : "N/A"
            }
          ></Column>
          <Column sortable field="createdAt" header={t("createdAt")}></Column>
          <Column
            body={(rowData) => (
              <ButtonGroup size="sm">
                <Link
                  to={`/${lang}/client/${rowData.id}`}
                  className="btn btn-outline-light"
                >
                  <i className="fa fa-eye" />
                </Link>
              </ButtonGroup>
            )}
          ></Column>
        </ReusableDataTable>
      </Card.Body>
    </Card>
  );
};

export default ListClient;
